<template>
  <login-component @login="handleLogin"></login-component>
</template>

<script>
import LoginComponent from '@/components/user/LoginComponent'
import SessionRefresh from '@/components/modals/SessionRefresh'
import {mapGetters, mapMutations} from 'vuex'
import axios from 'axios'
import addSeconds from "date-fns/add_seconds"
import subtractMinutes from 'date-fns/sub_minutes'
import differenceInMilliSeconds from 'date-fns/difference_in_milliseconds'

export default {
  components: {LoginComponent, SessionRefresh},
  name:"Login",
  data () {
    return {
      redirect: '/dashboard'
    }
  },
  computed: {
    ...mapGetters ([
        'base_url', 'token_expiry'
    ])
  },
  methods: {        
    ...mapMutations([
        'SET_BREADCRUMB'
    ]),
    setBreadcrumb: function(){
      this.SET_BREADCRUMB(this.$route.meta.breadcrumb)
    },
    refreshToken: function () {
      this.$modal.open({
        parent: this,
        component: SessionRefresh,
        hasModalCArd: true,
        props: {
        }
      })
    },
    handleLogin(user){
      axios.post(`${this.base_url}accounts/login/`, user)
        .then(response => {
          window.localStorage.setItem('valchrom-token', response.data.token);
          window.localStorage.setItem('valchrom-user', response.data.user);
          const token_expiry = addSeconds(new Date(), 86400); // 1 day
          window.localStorage.setItem("valchrom-token-expiry", token_expiry);
          response.data['token_expiry'] = token_expiry;
          this.$store.dispatch('login', response.data);
          this.createSessionTimeout();
          if(this.redirect)
              this.$router.push({path: this.redirect});
        })
        .catch(error => {
          this.$toast.open({
              duration: 5000,
              message: error.response.data,
              position: 'is-top',
              type: 'is-danger'
          })
        });
    },
    createSessionTimeout() {
      if(this.token_expiry) {
        let tenMinutesBeforeExpiry = subtractMinutes(this.token_expiry, 10);
        const now = new Date();
        this.refreshTimeout = setTimeout(this.refreshToken, differenceInMilliSeconds(tenMinutesBeforeExpiry, now));
      }
    }
  },
  mounted: function(){
    this.setBreadcrumb()
    this.redirect = this.$route.query.redirect || this.redirect;
    console.log(this.$route.query, this.redirect)
  }
}
</script>